import store from '@/store';

const router = [
  {
    path: '/escola',
    meta: {
      tagTela: 'escola',
      tagTelaFuncao: 'read',
      breadCrumb: 'Escola',
    },
    component: () => import('@/views/Escola.vue'),
  },
  {
    path: '/tipo-de-sala',
    meta: {
      tagTela: 'tiposala',
      tagTelaFuncao: 'read',
      breadCrumb: 'Tipo de Sala',
    },
    component: () => import('@/views/TipoSala.vue'),
  },
  {
    path: '/sala-escola',
    meta: {
      tagTela: 'salaescola',
      tagTelaFuncao: 'read',
      breadCrumb: 'Sala Escola',
    },
    component: () => import('@/views/SalaEscola.vue'),
  },
  {
    path: '/disciplina',
    meta: {
      tagTela: 'disciplina',
      tagTelaFuncao: 'read',
      breadCrumb: 'Disciplinas',
    },
    component: () => import('@/views/Disciplina'),
  },
  {
    path: '/area-de-conhecimento',
    meta: {
      tagTela: 'areaconhecimento',
      tagTelaFuncao: 'read',
      breadCrumb: 'Área de Conhecimento',
    },
    component: () => import('@/views/AreaConhecimento'),
  },
  {
    path: '/tabela-simples',
    name: 'tabelas',
    meta: {
      allowed: true,
      breadCrumb: 'Tabelas',
    },
    component: () => import('@/views/TabelaSimples'),
    props: true,
  },
  {
    path: '/corte-etario',
    name: 'corte-etario',
    meta: {
      tagTela: '',
      tagTelaFuncao: 'read',
      breadCrumb: 'Corte Etário',
    },
    component: () => import('@/views/CorteEtario'),
  },
  {
    path: '/etapa-escolar',
    name: 'estapaescolar',
    meta: {
      tagTela: 'etapaescolar',
      tagTelaFuncao: 'read',
      breadCrumb: 'Etapas Escolares',
    },
    component: () => import('@/views/EtapaEscolar'),
  },
  {
    path: '/etapa-escolar-escola',
    name: 'etapasporescola',
    meta: {
      tagTela: 'etapasporescola',
      tagTelaFuncao: 'read',
      breadCrumb: 'Etapas Escolares por Escola',
    },
    component: () => import('@/views/EtapaEscolarEscola'),
  },
  {
    path: '/atividade-avaliativa',
    name: 'atividadeavaliativa',
    meta: {
      tagTela: 'atividadeavaliativa',
      tagTelaFuncao: 'read',
      breadCrumb: 'Atividade Avaliativa',
    },
    component: () => import('@/views/AtividadeAvaliativa'),
  },
  {
    path: '/distribuir-notas',
    name: 'distribuirnotas',
    meta: {
      tagTela: 'distribuirnotas',
      tagTelaFuncao: 'read',
      breadCrumb: 'Distribuir Notas',
    },
    component: () => import('@/views/DistribuirNotas'),
  },
  {
    path: '/configuracao-ano-avaliativo',
    name: 'configuracaoanoavaliativo',
    meta: {
      tagTela: 'configanoletivo',
      tagTelaFuncao: 'read',
      breadCrumb: 'Configuração Ano Avaliativo',
    },
    component: () => import('@/views/ConfiguracaoAnoAvaliativo'),
  },
  {
    path: '/necessidade-especial',
    meta: {
      tagTela: 'necessidadeespecial',
      tagTelaFuncao: 'read',
      breadCrumb: 'Necessidade Especial',
    },
    component: () => import('@/views/NecessidadeEspecial.vue'),
  },
  {
    path: '/distribuir-conceito',
    meta: {
      tagTela: 'distribuirconceito',
      tagTelaFuncao: 'read',
      breadCrumb: 'Distribuir Conceito',
    },
    component: () => import('@/views/DistribuirConceito.vue'),
  },
  {
    path: '/conceitos',
    meta: {
      tagTela: 'conceitos',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cadastro de Conceitos',
      hasProgress: true,
    },
    component: () => import('@/views/conceitos/Conceitos'),
  },
  {
    path: '/conceitos/novo',
    props: true,
    meta: {
      tagTela: 'conceitos',
      tagTelaFuncao: 'read',
      breadCrumb: 'Novo Conceito',
      hasProgress: true,
    },
    component: () => import('@/views/conceitos/ConceitosCadastro'),
  },
  {
    path: '/conceitos/:id',
    props: true,
    meta: {
      tagTela: 'conceitos',
      tagTelaFuncao: 'read',
      hasProgress: true,
      breadCrumb: 'Alterar Conceito',
    },
    component: () => import('@/views/conceitos/ConceitosCadastro'),
  },
  {
    path: '/sincronizar-ei',
    meta: {
      tagTela: 'sincronizarei',
      tagTelaFuncao: 'read',
      breadCrumb: 'Sincronizar Dados',
    },
    component: () => import('@/views/SincronizarEi.vue'),
  },
  {
    path: '/atena',
    meta: {
      tagTela: 'atenaperfil',
      tagTelaFuncao: 'read',
      breadCrumb: 'Atena',
      breadCrumbDisabled: true,
    },
  },
  {
    path: '/atena/perfil',
    meta: {
      tagTela: 'atenaperfil',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cadastro Perfil de Acesso',
    },
    component: () => import('@/views/atena/Perfil'),
  },
  {
    path: '/atena/tela-grupo',
    meta: {
      tagTela: 'atenatelagrupo',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cadastro Grupo de Telas',
    },
    component: () => import('@/views/atena/TelaGrupo'),
  },
  {
    path: '/atena/tela-subgrupo',
    meta: {
      tagTela: 'atenatelasubgrupo',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cadastro Subgrupo de Telas',
    },
    component: () => import('@/views/atena/TelaSubGrupo'),
  },
  {
    path: '/atena/tela',
    meta: {
      hasProgress: true,
      tagTela: 'atenatela',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cadastro Tela e Permissões',
    },
    component: () => import('@/views/atena/tela/Tela'),
  },
  {
    path: '/atena/tela/novo',
    meta: {
      tagTela: 'atenatela',
      tagTelaFuncao: 'read',
      breadCrumb: 'Nova Tela',
    },
    component: () => import('@/views/atena/tela/TelaCadastro'),
  },
  {
    path: '/atena/tela/:id',
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'atenatela',
      tagTelaFuncao: 'read',
      breadCrumb: 'Alterar Tela',
    },
    component: () => import('@/views/atena/tela/TelaCadastro'),
  },
  {
    path: '/atena/tela/:id/permissoes',
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'atenatela',
      tagTelaFuncao: 'read',
      breadCrumb: 'Permissões Tela',
    },
    component: () => import('@/views/atena/tela/Permissoes'),
  },
  {
    path: '/atena/usuario',
    meta: {
      hasProgress: true,
      tagTela: 'atenausuario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Cadastro Usuário',
    },
    component: () => import('@/views/atena/usuario/Usuario'),
  },
  {
    path: '/atena/usuario/novo',
    meta: {
      tagTela: 'atenausuario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Novo Usuário',
    },
    component: () => import('@/views/atena/usuario/UsuarioCadastro'),
  },
  {
    path: '/atena/usuario/:id',
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'atenausuario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Alterar Usuário',
    },
    component: () => import('@/views/atena/usuario/UsuarioCadastro'),
  },
  {
    path: '/atena/usuario/:idUsuario/perfil',
    name: 'UsuarioPerfil',
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'atenausuario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Perfil',
    },
    component: () => import('@/views/atena/usuario/UsuarioPerfil'),
  },
  {
    path: '/atena/usuario/:idUsuario/perfil/novo',
    props: true,
    meta: {
      tagTela: 'atenausuario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Novo Perfil',
    },
    component: () => import('@/views/atena/usuario/UsuarioPerfilCadastro'),
  },
  {
    path: '/atena/usuario/:idUsuario/perfil/:idUsuarioPerfil',
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'atenausuario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Alterar Perfil',
    },
    component: () => import('@/views/atena/usuario/UsuarioPerfilCadastro'),
  },
  {
    path: '/autorizacao-diario',
    meta: {
      tagTela: 'autodiarioprof',
      tagTelaFuncao: 'read',
      breadCrumb: 'Reabrir Diário',
      hasProgress: true,
    },
    component: () => import('@/views/autorizacao-diario/AutorizacaoDiario'),
  },
  {
    path: '/autorizacao-diario/novo',
    props: true,
    meta: {
      tagTela: 'autodiarioprof',
      tagTelaFuncao: 'read',
      breadCrumb: 'Nova Autorização',
      hasProgress: true,
    },
    component: () => import('@/views/autorizacao-diario/AutorizacaoDiarioCadastro'),
  },
  {
    path: '/autorizacao-diario/:id',
    props: true,
    meta: {
      tagTela: 'autodiarioprof',
      tagTelaFuncao: 'read',
      hasProgress: true,
      breadCrumb: 'Alterar Autorização Diário',
    },
    component: () => import('@/views/autorizacao-diario/AutorizacaoDiarioCadastro'),
  },
  {
    path: '/gerencial/vincular-perfil/',
    props:true,
    meta: {
      tagTela: 'perfilusuario',
      tagTelaFuncao: 'read',
      hasProgress: true,
      breadCrumb: 'Vincular Perfil',
    },
    component: () => import('@/views/VincularPerfil'),
  },
  {
    path: '/gerencial/vincular-perfil/:idUsuario/perfil/novo',
    props: true,
    meta: {
      tagTela: 'perfilusuario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Novo Perfil',
    },
    component: () => import('@/views/VincularPerfilCadastro'),
  },
  {
    path: '/gerencial/vincular-perfil/:idUsuario/perfil/:idUsuarioPerfil',
    props: true,
    meta: {
      hasProgress: true,
      tagTela: 'perfilusuario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Alterar Perfil',
    },
    component: () => import('@/views/VincularPerfilCadastro'),
  },
  {
    path: '/local-externo',
    meta: {
      tagTela: 'localexterno',
      tagTelaFuncao: 'read',
      breadCrumb: 'Local Externo',
    },
    component: () => import('@/views/LocalExterno.vue'),
  },
  {
    path: '/horario',
    meta: {
      tagTela: 'horario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Horário',
    },
    component: () => import('@/views/Horario.vue'),
  },
  {
    path: '/perfil-ano-letivo',
    meta: {
      tagTela: 'perfilanoletivo',
      tagTelaFuncao: 'read',
      breadCrumb: 'Perfil do Ano Letivo',
    },
    component: () => import('@/views/PerfilAnoLetivo.vue'),
  },
  {
    path: '/area-atuacao',
    meta: {
      tagTela: 'areaatuacao',
      tagTelaFuncao: 'read',
      breadCrumb: 'Área de Atuação',
    },
    component: () => import('@/views/AreaAtuacao.vue'),
  },
  {
    path: '/cancelamento-diario',
    meta: {
      tagTela: 'canceldiario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Autorizar Cancelamento de Diário',
      hasProgress: true,
    },
    component: () => import('@/views/cancelamento-diario/CancelamentoDiario'),
  },
  {
    path: '/cancelamento-diario/novo',
    props: true,
    meta: {
      tagTela: 'canceldiario',
      tagTelaFuncao: 'read',
      breadCrumb: 'Nova Autorização',
      hasProgress: true,
    },
    component: () => import('@/views/cancelamento-diario/CancelamentoDiarioCadastro'),
  },
  {
    path: '/cancelamento-diario/:id',
    props: true,
    meta: {
      tagTela: 'canceldiario',
      tagTelaFuncao: 'read',
      hasProgress: true,
      breadCrumb: 'Alterar Autorização Cancelamento de Diário',
    },
    component: () => import('@/views/cancelamento-diario/CancelamentoDiarioCadastro'),
  },
];


export default router;



// {
//   path: '/atena/usuario/:idUsuario/perfil',
//   props: true,
//   meta: {
//     hasProgress: true,
//     tagTela: 'atenausuario',
//     tagTelaFuncao: 'read',
//     breadCrumb: 'Perfil',
//   },
//   component: () => import('@/views/atena/usuario/UsuarioPerfil'),
// },
